import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, tap } from 'rxjs';
import { UseCase } from '../UseCase';
import { DatabaseService } from '@/app/Data/services/Database/database.service';
import { Note } from '@/app/core/Models/Note';
import { INotesRepository } from '@/app/core/IRepositories/INotesRepository';
import { NoteBody } from '@/app/Data/DTO/NoteBodyDto';
import { INotificationRepository } from '@/app/core/IRepositories/INotificationRepository';
import { IMediaRepository } from '../../IRepositories/IMediaRepository';

@Injectable({
  providedIn: 'root',
})
export class UpdateUnclassifiedChannelNoteUseCase
  implements UseCase<NoteBody, Note>
{
  constructor(
    private notesRepository: INotesRepository,
    private mediaRepository: IMediaRepository,
  ) { }

  async execute(body: NoteBody): Promise<Note> {
    const { note, unclassifiedChannelId, noteId } = body.getBody();
    if (body.hasNewAttachments) {
      const media_urls = await firstValueFrom(
        this.mediaRepository.uploadAttachments(body.getBodyAttachment(), body.uploadProgress$)
      );
      note.attachments = [...(note.attachments ?? []), ...media_urls]
    }
    const noteResult = await firstValueFrom(
      this.notesRepository.updateUnclassifiedChannelNote(note, noteId!, unclassifiedChannelId!)
    );
    this.notesRepository.saveNotes([noteResult]);
    return noteResult;
  }
}
